// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import bootflat & bootstrap
import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap.css'

import Vue from 'vue'
// import iView from 'iview'
// import 'iview/dist/styles/iview.css'

import axios from 'axios'
// import moment from 'moment'
import App from './App'
import router from './router'

// Vue.prototype.config = config
// Vue.prototype.$echarts = echarts
// Vue.prototype.$moment = moment
Vue.config.productionTip = false

const defaultHeaders = {
    Accept: 'application/json, text/plain, */*; charset=utf-8',
    'Content-Type': 'application/json; charset=utf-8',
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache'
}
// 设置默认头
Object.assign(axios.defaults.headers.common, defaultHeaders)

// Vue.use(iView)
Vue.prototype.debug = false
Vue.prototype.axios = axios.create()
// http请求拦截器
Vue.prototype.axios.interceptors.request.use(config => {
    // element ui Loading方法
    // loadinginstace = Loading.service({ fullscreen: true })
    // console.log('axios.req: ' + JSON.stringify(config))
    // console.log('## axios.req: ' + config.method + ', ' + config.url)
    return config
}, error => {
    // loadinginstace.close()
    // Message.error({
    //     message: '加载超时'
    // })
    return Promise.reject(error)
})
// http响应拦截器
Vue.prototype.axios.interceptors.response.use(response => {
    // 响应成功关闭loading
    // loadinginstace.close()
    // console.log('axios.resp: ' + JSON.stringify(response))
    // console.log('## axios.resp: ' + response.status + ', ' + JSON.stringify(response.data))
    return response
}, error => {
    // loadinginstace.close()
    // Message.error({
    //     message: '加载失败'
    // })
    return Promise.reject(error)
})

// 解析 URL 参数
Vue.prototype.nvParseUrlParams = function () {
    var name, value
    // 取得整个地址栏
    var str = location.href
    var num = str.indexOf('?')
    // 取得所有参数   stringvar.substr(start [, length ]
    str = str.substr(num + 1)
    // 各个参数放到数组里
    var arr = str.split('&')
    for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf('=')
        if (num > 0) {
            name = arr[i].substring(0, num)
            value = arr[i].substr(num + 1)
            this[name] = value
            if (Vue.prototype.debug) {
                console.log('[' + name + ']=' + value)
            }
            if (name === 'hl' && value !== undefined) {
                Vue.prototype.nvSetLocale(value)
            }
        }
    }
}

// 获取语言, 根据不同浏览器厂商做适配
// PC:
// Chrome: 中文简体(zh-CN)/
// Safari: 中文简体(zh-CN)/

// Android monitor:
// Chrome: en-US, zh-CN(简体中文), zh-TW(繁体中文/粤语)

// iOS simulator:
// Safari: en-US, zh-CN(简体中文), zh-TW(繁体中文)
Vue.prototype.nvGetLanguage = function () {
    // console.log('window.navigator.language: ' + window.navigator.language)
    var language
    if (Vue.prototype.locale !== undefined) {
        language = Vue.prototype.locale.toLowerCase()
    } else {
        language = window.navigator.language.toLowerCase()
    }
    var languages = [ 'de', 'en', 'es', 'fr', 'it', 'ja', 'pt', 'ru' ]
    if (language.startsWith('zh-tw') || (language.startsWith('zh') && language.endsWith('hant'))) {
        return 'zh-Hant'
    } else if (language.startsWith('zh') || language.startsWith('cn')) {
        return 'zh-Hans'
    } else {
        for (var i = 0, len = languages.length; i < len; i++) {
            var matched = languages[i]
            if (language.startsWith(matched)) {
                return matched
            }
        }
        return 'en'
    }
}

// 拼接本地资源路径
// prefix: */
// suffix: *
Vue.prototype.nvGetPath = function (prefix, suffix) {
    var path = prefix + Vue.prototype.nvGetLanguage() + '/' + suffix
    if (Vue.prototype.debug) {
        console.log('path: ' + path)
    }
    return path
}

// 读取本地静态资源中的 JSON 文件, 转化层 JSON 对象
// prefix = */
// suffix = *
Vue.prototype.nvGetJson = function (prefix, suffix, onFulfilled, onRejected) {
    var jsonPath = Vue.prototype.nvGetPath(prefix, suffix)
    Vue.prototype.axios.get(jsonPath).then(response => {
        if (Vue.prototype.debug) {
            console.log('axios: path:' + jsonPath + ', response:' + JSON.stringify(response.data))
        }
        if (onFulfilled !== undefined) {
            onFulfilled(response)
        }
    }, exception => {
        if (Vue.prototype.debug) {
            console.log('throws: ' + JSON.stringify(exception))
        }
        if (onRejected !== undefined) {
            onRejected(exception)
        }
    })
}

// 减少拼接的逻辑, 前缀路径固定
Vue.prototype.nvGetDefaultJson = function (suffix, onFulfilled, onRejected) {
    Vue.prototype.nvGetJson('static/data/', suffix, onFulfilled, onRejected)
}

// 加载字符串
Vue.prototype.nvLoadStrings = function (context, onNvStringsLoaded) {
    if (Vue.prototype.nvStrings === undefined) {
        Vue.prototype.nvForceLoadStrings(context, onNvStringsLoaded)
    } else {
        if (context !== undefined) {
            context['nvStrings'] = Vue.prototype.nvStrings
        }
        if (onNvStringsLoaded !== undefined) {
            onNvStringsLoaded(Vue.prototype.nvStrings)
        }
    }
}

Vue.prototype.nvForceLoadStrings = function (context, onNvStringsLoaded) {
    this.nvGetDefaultJson('strings.json', response => {
        Vue.prototype.nvStrings = response.data
        if (context !== undefined) {
            context['nvStrings'] = response.data
        }
        if (onNvStringsLoaded !== undefined) {
            onNvStringsLoaded(context)
        }
    })
}

Vue.prototype.nvSetLocale = function (locale) {
    if (locale !== undefined) {
        if (Vue.prototype.debug) {
            console.log('Vue.prototype.locale: set to -> ' + locale)
        }
        this.locale = locale
        this.nvForceLoadStrings()
    }
}

// 默认加载方法
Vue.prototype.nvOnLoad = function (onNvStringsLoaded) {
    this.nvParseUrlParams()
    this.nvLoadStrings(this, context => {
        if (Vue.prototype.titleKey !== undefined &&
            Vue.prototype.nvStrings !== undefined &&
            Vue.prototype.nvStrings[Vue.prototype.titleKey] !== undefined) {
            document.title = Vue.prototype.nvStrings[Vue.prototype.titleKey]
        }
        onNvStringsLoaded(context)
    })
}

router.beforeEach((to, from, next) => {
    if (to.meta !== undefined && to.meta.title_key !== undefined) {
        document.title = ''
        Vue.prototype.titleKey = to.meta.title_key
    } else {
        document.title = ''
    }
    next()
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js